import { CognateWord } from "../activityTypes";

// =============================================================================
// CION Pattern Words (-ción = -tion)
// =============================================================================

export const CION_WORDS: CognateWord[] = [
  {
    id: "comunicación",
    spanish: "comunicación",
    english: "communication",
    pattern: "CION",
  },
  {
    id: "información",
    spanish: "información",
    english: "information",
    pattern: "CION",
  },
  {
    id: "situación",
    spanish: "situación",
    english: "situation",
    pattern: "CION",
  },
  {
    id: "nación",
    spanish: "nación",
    english: "nation",
    pattern: "CION",
  },
  {
    id: "educación",
    spanish: "educación",
    english: "education",
    pattern: "CION",
  },
  {
    id: "aplicación",
    spanish: "aplicación",
    english: "application",
    pattern: "CION",
  },
];

// =============================================================================
// ANTE Pattern Words (-ante = -ant)
// =============================================================================

export const ANTE_WORDS: CognateWord[] = [
  {
    id: "importante",
    spanish: "importante",
    english: "important",
    pattern: "ANTE",
  },
  {
    id: "restaurante",
    spanish: "restaurante",
    english: "restaurant",
    pattern: "ANTE",
  },
  {
    id: "elegante",
    spanish: "elegante",
    english: "elegant",
    pattern: "ANTE",
  },
  {
    id: "interesante",
    spanish: "interesante",
    english: "interesting",
    pattern: "ANTE",
  },
  {
    id: "constante",
    spanish: "constante",
    english: "constant",
    pattern: "ANTE",
  },
];
// =============================================================================
// DAD Pattern Words (-dad = -ty)
// =============================================================================

export const DAD_WORDS: CognateWord[] = [
  {
    id: "realidad",
    spanish: "realidad",
    english: "reality",
    pattern: "DAD",
  },
  {
    id: "actividad",
    spanish: "actividad",
    english: "activity",
    pattern: "DAD",
  },
  {
    id: "universidad",
    spanish: "universidad",
    english: "university",
    pattern: "DAD",
  },
  {
    id: "posibilidad",
    spanish: "posibilidad",
    english: "possibility",
    pattern: "DAD",
  },
  {
    id: "comunidad",
    spanish: "comunidad",
    english: "community",
    pattern: "DAD",
  },
  {
    id: "oportunidad",
    spanish: "oportunidad",
    english: "opportunity",
    pattern: "DAD",
  },
];

// =============================================================================
// MENTE Pattern Words (-mente = -ly)
// =============================================================================

export const MENTE_WORDS: CognateWord[] = [
  {
    id: "normalmente",
    spanish: "normalmente",
    english: "normally",
    pattern: "MENTE",
  },
  {
    id: "exactamente",
    spanish: "exactamente",
    english: "exactly",
    pattern: "MENTE",
  },
  {
    id: "rápidamente",
    spanish: "rápidamente",
    english: "rapidly",
    pattern: "MENTE",
  },
  {
    id: "completamente",
    spanish: "completamente",
    english: "completely",
    pattern: "MENTE",
  },
  {
    id: "finalmente",
    spanish: "finalmente",
    english: "finally",
    pattern: "MENTE",
  },
];
// =============================================================================
// All Cognate Words (for Module 3 review)
// =============================================================================

export const ALL_COGNATE_WORDS: CognateWord[] = [
  ...CION_WORDS,
  ...ANTE_WORDS,
  ...DAD_WORDS,
  ...MENTE_WORDS,
];

// =============================================================================
// Module 3 Flashcard Bonus Words (for final celebrate reference)
// =============================================================================

export const MODULE_3_FLASHCARD_WORDS: CognateWord[] = [
  // CION
  { id: "motivación", spanish: "motivación", english: "motivation", pattern: "CION" },
  { id: "imaginación", spanish: "imaginación", english: "imagination", pattern: "CION" },
  { id: "invitación", spanish: "invitación", english: "invitation", pattern: "CION" },
  // ANTE
  { id: "arrogante", spanish: "arrogante", english: "arrogant", pattern: "ANTE" },
  { id: "brillante", spanish: "brillante", english: "brilliant", pattern: "ANTE" },
  // DAD
  { id: "identidad", spanish: "identidad", english: "identity", pattern: "DAD" },
  { id: "curiosidad", spanish: "curiosidad", english: "curiosity", pattern: "DAD" },
  { id: "necesidad", spanish: "necesidad", english: "necessity", pattern: "DAD" },
  // MENTE
  { id: "totalmente", spanish: "totalmente", english: "totally", pattern: "MENTE" },
  { id: "obviamente", spanish: "obviamente", english: "obviously", pattern: "MENTE" },
];
